import React, { useContext, useEffect, useState } from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faCheckCircle, faTimesCircle } from "@fortawesome/free-solid-svg-icons";

import StatusItem from "./components/status-item";
import Accordion from "../accordion";

import { getTaskContextByKey } from "../task-list/lib/taskData";
import { useAlert } from "hooks/useAlert";
import { SettingsContext } from "contexts/settings";

import "./shipment-status.scss";
import { useParams } from "react-router-dom";

// TODO: refactor  this component
const ShipmentStatus = ({ products, openFullUpcs, showSubLabel }) => {
    const params = useParams();
    const [upcList, setUpcList] = useState([]);
    const { toggleAlert } = useAlert();
    const { settings } = useContext(SettingsContext);

    const sortMultipleShipments = (a, b) => {
        if (products) {
            const fullUpcA = a.shipmentProduct.modifier ? `${a.upc}-${a.shipmentProduct.modifier}` : a.upc;
            const fullUpcB = b.shipmentProduct.modifier ? `${b.upc}-${b.shipmentProduct.modifier}` : b.upc;

            return openFullUpcs.includes(fullUpcB) - openFullUpcs.includes(fullUpcA);
        }

        return 0;
    };

    useEffect(() => {
        async function fetchData() {
            if (!products) {
                const upcs = await getTaskContextByKey(params.shipmentKey);

                setUpcList(upcs);
            }
        }

        fetchData();
    }, []);

    useEffect(() => {
        if (products) {
            setUpcList(products.sort(sortMultipleShipments));
        }
    }, [products]);

    useEffect(() => {
        if (settings.globalNotifications.messages.length) {
            toggleAlert();
        }
    }, [settings.globalNotifications.messages.length]);

    var startingIndex = -1;
    let startingIndexes;

    if (products) {
        startingIndexes = upcList
            .map(({ upc, shipmentProduct }) => (shipmentProduct.modifier ? `${upc}-${shipmentProduct.modifier}` : upc))
            .reduce((indexes, fullUpc, currentIndex) => {
                const isSelected = openFullUpcs.includes(fullUpc);

                if (isSelected) {
                    indexes.push(currentIndex);
                }

                return indexes;
            }, []);
    }

    const upcs = upcList.map((product, index) => {
        const productModifier = product.productModifier ? product.productModifier : product.shipmentProduct && product.shipmentProduct.modifier;
        const fullUpc = productModifier ? `${product.upc}-${productModifier}` : product.upc;
        const icon = product.isFinalized ? (
            <div className="check-complete">
                <FontAwesomeIcon icon={faCheckCircle} />
            </div>
        ) : (
            <div className="check-incomplete">
                <FontAwesomeIcon icon={faTimesCircle} />
            </div>
        );
        const label = (
            <div className="upc-title">
                <div>
                    {icon} <h1>{fullUpc}</h1>
                </div>
                {showSubLabel && <div>BIN ID: {product.binTrackingNumber}</div>}
            </div>
        );

        if (window.location.hash && window.location.hash === `#${product.key}`) {
            startingIndex = index;
        }

        return <StatusItem key={`upc-${product.key}`} anchor={product.key} product={product} label={label} />;
    });
    
    return (
        <div className="container">
            <h1>Shipment Status</h1>
            <Accordion className="shipment-status" arrowOnly={true} loadOnOpen={true} startingIndex={startingIndex}
                       startingIndexes={startingIndexes}>
                {upcs}
            </Accordion>
        </div>
    );
};

export default ShipmentStatus;
